const BASE_URL = process.env.REACT_APP_API_CALL_BASE_URL;

// POST request to create new location
export const createLocation = async (clinicID, newLocation, token) => {
    try {
        const response = await fetch(`${BASE_URL}/invoco/locations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ location_name: newLocation, clinic_id: clinicID }),
        });
        if (!response.ok) throw new Error(`Error ${response.status}`);

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Failed to create location', error);
    }
}

// POST create a new doctor
export const createDoctor = async (doctorData, token) => {
    try {
        const response = await fetch(`${BASE_URL}/invoco/doctors`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(doctorData),
        });
        if (!response.ok) throw new Error(`Error ${response.status}`);

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Failed to create a doctor', error);
    }
};

// POST create a new user
export const createUser = async (userData, token) => {
    try {
        const response = await fetch(`${BASE_URL}/invoco/users`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(userData),
        });
        if (!response.ok) throw new Error(`Error ${response.status}`);

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to create new user', error);
    }
};

// DELETE request - DELETE location


// DELETE request - DELETE Clinic and all associated locations


// DELETE request - DELETE users